export default __webpack_public_path__ + "static/media/step03.8a492875.png";